/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AllShipmentsCustomerAnalytics } from "./AllShipmentsCustomerAnalytics";
import {
  AllShipmentsCustomerAnalyticsFromJSON,
  AllShipmentsCustomerAnalyticsFromJSONTyped,
  AllShipmentsCustomerAnalyticsToJSON,
  AllShipmentsCustomerAnalyticsToJSONTyped,
} from "./AllShipmentsCustomerAnalytics";
import type { AllShipmentsCarrierAnalytics } from "./AllShipmentsCarrierAnalytics";
import {
  AllShipmentsCarrierAnalyticsFromJSON,
  AllShipmentsCarrierAnalyticsFromJSONTyped,
  AllShipmentsCarrierAnalyticsToJSON,
  AllShipmentsCarrierAnalyticsToJSONTyped,
} from "./AllShipmentsCarrierAnalytics";
import type { AllShipmentsBucket } from "./AllShipmentsBucket";
import {
  AllShipmentsBucketFromJSON,
  AllShipmentsBucketFromJSONTyped,
  AllShipmentsBucketToJSON,
  AllShipmentsBucketToJSONTyped,
} from "./AllShipmentsBucket";
import type { AllShipmentsSplit } from "./AllShipmentsSplit";
import {
  AllShipmentsSplitFromJSON,
  AllShipmentsSplitFromJSONTyped,
  AllShipmentsSplitToJSON,
  AllShipmentsSplitToJSONTyped,
} from "./AllShipmentsSplit";
import type { AllShipmentsOverviewStats } from "./AllShipmentsOverviewStats";
import {
  AllShipmentsOverviewStatsFromJSON,
  AllShipmentsOverviewStatsFromJSONTyped,
  AllShipmentsOverviewStatsToJSON,
  AllShipmentsOverviewStatsToJSONTyped,
} from "./AllShipmentsOverviewStats";
import type { AllShipmentsTimeSeriesBucket } from "./AllShipmentsTimeSeriesBucket";
import {
  AllShipmentsTimeSeriesBucketFromJSON,
  AllShipmentsTimeSeriesBucketFromJSONTyped,
  AllShipmentsTimeSeriesBucketToJSON,
  AllShipmentsTimeSeriesBucketToJSONTyped,
} from "./AllShipmentsTimeSeriesBucket";
import type { AllShipmentsLocationAnalytics } from "./AllShipmentsLocationAnalytics";
import {
  AllShipmentsLocationAnalyticsFromJSON,
  AllShipmentsLocationAnalyticsFromJSONTyped,
  AllShipmentsLocationAnalyticsToJSON,
  AllShipmentsLocationAnalyticsToJSONTyped,
} from "./AllShipmentsLocationAnalytics";
import type { AllShipmentsSlice } from "./AllShipmentsSlice";
import {
  AllShipmentsSliceFromJSON,
  AllShipmentsSliceFromJSONTyped,
  AllShipmentsSliceToJSON,
  AllShipmentsSliceToJSONTyped,
} from "./AllShipmentsSlice";
import type { AllShipmentsAccessorialAnalytics } from "./AllShipmentsAccessorialAnalytics";
import {
  AllShipmentsAccessorialAnalyticsFromJSON,
  AllShipmentsAccessorialAnalyticsFromJSONTyped,
  AllShipmentsAccessorialAnalyticsToJSON,
  AllShipmentsAccessorialAnalyticsToJSONTyped,
} from "./AllShipmentsAccessorialAnalytics";
import type { AllShipmentsFreightClassAnalytics } from "./AllShipmentsFreightClassAnalytics";
import {
  AllShipmentsFreightClassAnalyticsFromJSON,
  AllShipmentsFreightClassAnalyticsFromJSONTyped,
  AllShipmentsFreightClassAnalyticsToJSON,
  AllShipmentsFreightClassAnalyticsToJSONTyped,
} from "./AllShipmentsFreightClassAnalytics";
import type { AllShipmentsLaneAnalytics } from "./AllShipmentsLaneAnalytics";
import {
  AllShipmentsLaneAnalyticsFromJSON,
  AllShipmentsLaneAnalyticsFromJSONTyped,
  AllShipmentsLaneAnalyticsToJSON,
  AllShipmentsLaneAnalyticsToJSONTyped,
} from "./AllShipmentsLaneAnalytics";

/**
 *
 * @export
 * @interface AllShipmentsStatistics
 */
export interface AllShipmentsStatistics {
  /**
   *
   * @type {AllShipmentsOverviewStats}
   * @memberof AllShipmentsStatistics
   */
  overview: AllShipmentsOverviewStats;
  /**
   *
   * @type {Array<AllShipmentsCarrierAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  carriers: Array<AllShipmentsCarrierAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsCustomerAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  customers: Array<AllShipmentsCustomerAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsLaneAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  topLanes: Array<AllShipmentsLaneAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsFreightClassAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  freightClasses: Array<AllShipmentsFreightClassAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsAccessorialAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  accessorials: Array<AllShipmentsAccessorialAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsLocationAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  topPickupLocations: Array<AllShipmentsLocationAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsLocationAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  topDeliveryLocations: Array<AllShipmentsLocationAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsLocationAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  topPickupStates: Array<AllShipmentsLocationAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsLocationAnalytics>}
   * @memberof AllShipmentsStatistics
   */
  topDeliveryStates: Array<AllShipmentsLocationAnalytics>;
  /**
   *
   * @type {Array<AllShipmentsBucket>}
   * @memberof AllShipmentsStatistics
   */
  weightDistribution: Array<AllShipmentsBucket>;
  /**
   *
   * @type {Array<AllShipmentsBucket>}
   * @memberof AllShipmentsStatistics
   */
  densityDistribution: Array<AllShipmentsBucket>;
  /**
   *
   * @type {Array<AllShipmentsBucket>}
   * @memberof AllShipmentsStatistics
   */
  distanceDistribution: Array<AllShipmentsBucket>;
  /**
   *
   * @type {Array<AllShipmentsBucket>}
   * @memberof AllShipmentsStatistics
   */
  pricingDistribution: Array<AllShipmentsBucket>;
  /**
   *
   * @type {Array<AllShipmentsBucket>}
   * @memberof AllShipmentsStatistics
   */
  handlingUnitDistribution: Array<AllShipmentsBucket>;
  /**
   *
   * @type {Array<AllShipmentsBucket>}
   * @memberof AllShipmentsStatistics
   */
  insuranceDistribution: Array<AllShipmentsBucket>;
  /**
   *
   * @type {Array<AllShipmentsTimeSeriesBucket>}
   * @memberof AllShipmentsStatistics
   */
  timeSeries: Array<AllShipmentsTimeSeriesBucket>;
  /**
   *
   * @type {Array<AllShipmentsSlice>}
   * @memberof AllShipmentsStatistics
   */
  bookedVsUnbooked: Array<AllShipmentsSlice>;
  /**
   *
   * @type {Array<AllShipmentsSlice>}
   * @memberof AllShipmentsStatistics
   */
  crossBorderSplit: Array<AllShipmentsSlice>;
  /**
   *
   * @type {Array<AllShipmentsSlice>}
   * @memberof AllShipmentsStatistics
   */
  revenueByCarrier: Array<AllShipmentsSlice>;
  /**
   *
   * @type {Array<AllShipmentsSlice>}
   * @memberof AllShipmentsStatistics
   */
  accessorialMix: Array<AllShipmentsSlice>;
  /**
   *
   * @type {AllShipmentsSplit}
   * @memberof AllShipmentsStatistics
   */
  perfectSplit: AllShipmentsSplit;
  /**
   *
   * @type {AllShipmentsSplit}
   * @memberof AllShipmentsStatistics
   */
  cspBookedSplit: AllShipmentsSplit;
}

/**
 * Check if a given object implements the AllShipmentsStatistics interface.
 */
export function instanceOfAllShipmentsStatistics(
  value: object,
): value is AllShipmentsStatistics {
  if (!("overview" in value) || value["overview"] === undefined) return false;
  if (!("carriers" in value) || value["carriers"] === undefined) return false;
  if (!("customers" in value) || value["customers"] === undefined) return false;
  if (!("topLanes" in value) || value["topLanes"] === undefined) return false;
  if (!("freightClasses" in value) || value["freightClasses"] === undefined)
    return false;
  if (!("accessorials" in value) || value["accessorials"] === undefined)
    return false;
  if (
    !("topPickupLocations" in value) ||
    value["topPickupLocations"] === undefined
  )
    return false;
  if (
    !("topDeliveryLocations" in value) ||
    value["topDeliveryLocations"] === undefined
  )
    return false;
  if (!("topPickupStates" in value) || value["topPickupStates"] === undefined)
    return false;
  if (
    !("topDeliveryStates" in value) ||
    value["topDeliveryStates"] === undefined
  )
    return false;
  if (
    !("weightDistribution" in value) ||
    value["weightDistribution"] === undefined
  )
    return false;
  if (
    !("densityDistribution" in value) ||
    value["densityDistribution"] === undefined
  )
    return false;
  if (
    !("distanceDistribution" in value) ||
    value["distanceDistribution"] === undefined
  )
    return false;
  if (
    !("pricingDistribution" in value) ||
    value["pricingDistribution"] === undefined
  )
    return false;
  if (
    !("handlingUnitDistribution" in value) ||
    value["handlingUnitDistribution"] === undefined
  )
    return false;
  if (
    !("insuranceDistribution" in value) ||
    value["insuranceDistribution"] === undefined
  )
    return false;
  if (!("timeSeries" in value) || value["timeSeries"] === undefined)
    return false;
  if (!("bookedVsUnbooked" in value) || value["bookedVsUnbooked"] === undefined)
    return false;
  if (!("crossBorderSplit" in value) || value["crossBorderSplit"] === undefined)
    return false;
  if (!("revenueByCarrier" in value) || value["revenueByCarrier"] === undefined)
    return false;
  if (!("accessorialMix" in value) || value["accessorialMix"] === undefined)
    return false;
  if (!("perfectSplit" in value) || value["perfectSplit"] === undefined)
    return false;
  if (!("cspBookedSplit" in value) || value["cspBookedSplit"] === undefined)
    return false;
  return true;
}

export function AllShipmentsStatisticsFromJSON(
  json: any,
): AllShipmentsStatistics {
  return AllShipmentsStatisticsFromJSONTyped(json, false);
}

export function AllShipmentsStatisticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsStatistics {
  if (json == null) {
    return json;
  }
  return {
    overview: AllShipmentsOverviewStatsFromJSON(json["overview"]),
    carriers: (json["carriers"] as Array<any>).map(
      AllShipmentsCarrierAnalyticsFromJSON,
    ),
    customers: (json["customers"] as Array<any>).map(
      AllShipmentsCustomerAnalyticsFromJSON,
    ),
    topLanes: (json["topLanes"] as Array<any>).map(
      AllShipmentsLaneAnalyticsFromJSON,
    ),
    freightClasses: (json["freightClasses"] as Array<any>).map(
      AllShipmentsFreightClassAnalyticsFromJSON,
    ),
    accessorials: (json["accessorials"] as Array<any>).map(
      AllShipmentsAccessorialAnalyticsFromJSON,
    ),
    topPickupLocations: (json["topPickupLocations"] as Array<any>).map(
      AllShipmentsLocationAnalyticsFromJSON,
    ),
    topDeliveryLocations: (json["topDeliveryLocations"] as Array<any>).map(
      AllShipmentsLocationAnalyticsFromJSON,
    ),
    topPickupStates: (json["topPickupStates"] as Array<any>).map(
      AllShipmentsLocationAnalyticsFromJSON,
    ),
    topDeliveryStates: (json["topDeliveryStates"] as Array<any>).map(
      AllShipmentsLocationAnalyticsFromJSON,
    ),
    weightDistribution: (json["weightDistribution"] as Array<any>).map(
      AllShipmentsBucketFromJSON,
    ),
    densityDistribution: (json["densityDistribution"] as Array<any>).map(
      AllShipmentsBucketFromJSON,
    ),
    distanceDistribution: (json["distanceDistribution"] as Array<any>).map(
      AllShipmentsBucketFromJSON,
    ),
    pricingDistribution: (json["pricingDistribution"] as Array<any>).map(
      AllShipmentsBucketFromJSON,
    ),
    handlingUnitDistribution: (
      json["handlingUnitDistribution"] as Array<any>
    ).map(AllShipmentsBucketFromJSON),
    insuranceDistribution: (json["insuranceDistribution"] as Array<any>).map(
      AllShipmentsBucketFromJSON,
    ),
    timeSeries: (json["timeSeries"] as Array<any>).map(
      AllShipmentsTimeSeriesBucketFromJSON,
    ),
    bookedVsUnbooked: (json["bookedVsUnbooked"] as Array<any>).map(
      AllShipmentsSliceFromJSON,
    ),
    crossBorderSplit: (json["crossBorderSplit"] as Array<any>).map(
      AllShipmentsSliceFromJSON,
    ),
    revenueByCarrier: (json["revenueByCarrier"] as Array<any>).map(
      AllShipmentsSliceFromJSON,
    ),
    accessorialMix: (json["accessorialMix"] as Array<any>).map(
      AllShipmentsSliceFromJSON,
    ),
    perfectSplit: AllShipmentsSplitFromJSON(json["perfectSplit"]),
    cspBookedSplit: AllShipmentsSplitFromJSON(json["cspBookedSplit"]),
  };
}

export function AllShipmentsStatisticsToJSON(
  json: any,
): AllShipmentsStatistics {
  return AllShipmentsStatisticsToJSONTyped(json, false);
}

export function AllShipmentsStatisticsToJSONTyped(
  value?: AllShipmentsStatistics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    overview: AllShipmentsOverviewStatsToJSON(value["overview"]),
    carriers: (value["carriers"] as Array<any>).map(
      AllShipmentsCarrierAnalyticsToJSON,
    ),
    customers: (value["customers"] as Array<any>).map(
      AllShipmentsCustomerAnalyticsToJSON,
    ),
    topLanes: (value["topLanes"] as Array<any>).map(
      AllShipmentsLaneAnalyticsToJSON,
    ),
    freightClasses: (value["freightClasses"] as Array<any>).map(
      AllShipmentsFreightClassAnalyticsToJSON,
    ),
    accessorials: (value["accessorials"] as Array<any>).map(
      AllShipmentsAccessorialAnalyticsToJSON,
    ),
    topPickupLocations: (value["topPickupLocations"] as Array<any>).map(
      AllShipmentsLocationAnalyticsToJSON,
    ),
    topDeliveryLocations: (value["topDeliveryLocations"] as Array<any>).map(
      AllShipmentsLocationAnalyticsToJSON,
    ),
    topPickupStates: (value["topPickupStates"] as Array<any>).map(
      AllShipmentsLocationAnalyticsToJSON,
    ),
    topDeliveryStates: (value["topDeliveryStates"] as Array<any>).map(
      AllShipmentsLocationAnalyticsToJSON,
    ),
    weightDistribution: (value["weightDistribution"] as Array<any>).map(
      AllShipmentsBucketToJSON,
    ),
    densityDistribution: (value["densityDistribution"] as Array<any>).map(
      AllShipmentsBucketToJSON,
    ),
    distanceDistribution: (value["distanceDistribution"] as Array<any>).map(
      AllShipmentsBucketToJSON,
    ),
    pricingDistribution: (value["pricingDistribution"] as Array<any>).map(
      AllShipmentsBucketToJSON,
    ),
    handlingUnitDistribution: (
      value["handlingUnitDistribution"] as Array<any>
    ).map(AllShipmentsBucketToJSON),
    insuranceDistribution: (value["insuranceDistribution"] as Array<any>).map(
      AllShipmentsBucketToJSON,
    ),
    timeSeries: (value["timeSeries"] as Array<any>).map(
      AllShipmentsTimeSeriesBucketToJSON,
    ),
    bookedVsUnbooked: (value["bookedVsUnbooked"] as Array<any>).map(
      AllShipmentsSliceToJSON,
    ),
    crossBorderSplit: (value["crossBorderSplit"] as Array<any>).map(
      AllShipmentsSliceToJSON,
    ),
    revenueByCarrier: (value["revenueByCarrier"] as Array<any>).map(
      AllShipmentsSliceToJSON,
    ),
    accessorialMix: (value["accessorialMix"] as Array<any>).map(
      AllShipmentsSliceToJSON,
    ),
    perfectSplit: AllShipmentsSplitToJSON(value["perfectSplit"]),
    cspBookedSplit: AllShipmentsSplitToJSON(value["cspBookedSplit"]),
  };
}
